import { createAction, createRequestTypes, createRequestActions } from './utils';
import keyMirror from 'react-utils/keyMirror';
export const ProfileOptionActionTypes = keyMirror({
  LOAD_PROFILE_OPTIONS: null
});
export const FETCH_PROFILE_OPTIONS = 'FETCH_PROFILE_OPTIONS';
export const FetchProfileOptionsActionTypes = createRequestTypes(FETCH_PROFILE_OPTIONS);
export const FetchProfileOptions = createRequestActions(FetchProfileOptionsActionTypes);
export const loadProfileOptions = () => createAction(ProfileOptionActionTypes.LOAD_PROFILE_OPTIONS, {
  data: {
    hubless: false
  }
});
export const loadProfileOptionsHubless = () => createAction(ProfileOptionActionTypes.LOAD_PROFILE_OPTIONS, {
  data: {
    hubless: true
  }
});